<template>
    <div class="input-group-append">
        <button type="button" class="btn btn-sm"
            data-toggle="tooltip" data-placement="top" title="Elegibilidade"
            :class="buttonColor"
            @click="verificaElegibilidade()"
            >
            <i class="fas fa-user-check" ></i>
        </button>

        <!-- Modal Elegibilidade -->
        <div class="modal fade" id="servicoOperadoraModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content" :class="color">
                    <div class="modal-body text-center">
                        <template v-if="paciente">
                            <h5>Elegibilidade</h5>
                            <h4>{{ ( this.plano && this.plano.operadora ) ? this.plano.operadora.search : "" }}</h4>
                            <h3 class="mb-3">{{ this.paciente.paciente_unidade.st_numero_carteira }}</h3>
                        </template>
                        <template v-if="retorno">
                            <div>
                                <i class="fas fa-question-circle fa-4x" v-if="retorno.fail"></i>
                                <i class="fa fa-check-circle fa-4x" v-else-if="retorno.elegivel"></i>
                                <i class="fas fa-times-circle fa-4x" v-else></i>
                                <div v-if="retorno.motivo" class="mt-3">{{ retorno.motivo }}</div>

                                <div class="card mt-3" v-if="retorno.html">
                                    <div class="card-body text-dark text-left">
                                        <div v-html="retorno.html"></div>
                                    </div>
                                </div>

                                <div class="mt-3 d-flex flex-column">
                                    <button type="button" class="btn btn-light" @click="fechar()">
                                        Fechar
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="spinner-border mt-1" style="width: 3rem; height: 3rem;" role="status" v-if="$store.state.loading">
                            <span class="sr-only">Loading...</span>
                            </div>
                            <div class="mt-3 lead">
                                {{ frases[frase_idx] }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Info Elegibilidade -->
        <div class="modal fade" id="consultaElegibilidade" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content bg-success text-white">
                    <div class="modal-body text-center">
                        <template v-if="paciente">

                            <h3>Elegibilidade</h3>
                            <h4>{{ ( this.plano && this.plano.operadora ) ? this.plano.operadora.search : "" }}</h4>

                        </template>
                        <template v-if="solicitacao_elegibilidade">
                            <h5 class="mb-1 mt-3">Paciente:<strong> {{ this.solicitacao_elegibilidade.st_nome_paciente }}</strong></h5>
                            <h5 class="mb-1">Matrícula: <strong>{{ this.solicitacao_elegibilidade.st_numero_carteira }}</strong></h5>
                            <h5 class="mb-1">Data/Hora transação: <strong>{{ this.solicitacao_elegibilidade.st_retorno_data_registro }}</strong></h5>
                            <h5 class="mb-1" v-if="this.solicitacao_elegibilidade.st_retorno_seq_transacao">Sequencial transação: <strong>{{ this.solicitacao_elegibilidade.st_retorno_seq_transacao }}</strong></h5>

                             <div class="mt-3 d-flex flex-column">
                                <button type="button" class="btn btn-light mx-3" @click="fecharConsulta()">
                                    Fechar
                                </button>
                                <button type="button" class="btn btn-warning mx-3 mt-3" @click="refazerElegibilidade()">
                                    Refazer consulta
                                </button>
                            </div>

                        </template>
                        <template v-else>
                            <div class="spinner-border mt-1" style="width: 3rem; height: 3rem;" role="status" v-if="$store.state.loading">
                            <span class="sr-only">Loading...</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    data () {
        return {
            msg: "",
            retorno: null,
            interval: null,
            frases: [
                'Conectando com a Operadora...',
                'Autenticando Credenciais...',
                'Localizando Paciente...',
                'Verificando Situação...',
                'Concluindo Verificação...',
            ],
            frase_idx: 0,
            solicitacao_elegibilidade: null
        }
    },

    props: ['paciente', 'plano', 'marcacao', 'elegivel'],

    computed: {
        color: function () {
            if ( !this.retorno )
                return 'bg-warning';

            if ( this.retorno.fail )
                return 'bg-dark text-white';
            else if ( this.retorno.elegivel )
                return 'bg-success text-white';
            else
                return 'bg-danger text-white';
        },
        buttonColor: function() {
            return this.elegivel
                    ? 'btn-outline-success'
                    : ( this.elegivel === false ? 'btn-outline-danger' : 'btn-outline-secondary');
        }
    },

    methods: {
        fechar() {
            $('#servicoOperadoraModal').modal('hide');
        },
        fecharConsulta() {
            $('#consultaElegibilidade').modal('hide');
        },

        verificaElegibilidade() {

            if(this.elegivel) {

                this.consultaSolicitacao();

            } else {

                this.elegibilidade();

            }

        },

        elegibilidade() {
            this.retorno = null;
            this.frase_idx = 0;
            this.msg = "Aguarde...";
            $('#servicoOperadoraModal').modal('show');

            this.interval = setInterval(() => {
                if ( this.frase_idx < this.frases.length - 1 )
                    this.frase_idx ++;
                else {
                    clearInterval(this.interval);
                    this.interval = null;
                }
            }, 2500);

            this.$util.atualizar(this, {
                service: "acesso_operadoras",
                func: "elegibilidade",
                redir_api: true,
                dados: {
                    id_marcacao: this.marcacao ? this.marcacao.id_marcacao : null,
                    id_paciente: this.paciente.id_pessoa,
                    id_plano: this.plano.id_plano,
                    st_numero_carteira: this.paciente.paciente_unidade.st_numero_carteira,
                    dt_validade_carteira: this.$util.getFormatDate(this.paciente.paciente_unidade.dt_validade_carteira, "YYYY-MM-DD", false),
                    st_nome_paciente: this.paciente.st_nome,
                },
                callback: res => {
                    this.retorno = res;
                    clearInterval(this.interval);
                    this.interval = null;

                    if ( res && res.hasOwnProperty('elegivel') ) {
                        this.$emit('changeElegebilidade', res.elegivel);
                    }
                }
            });
        },

        consultaSolicitacao() {

            this.solicitacao_elegibilidade = null;
            this.msg = "Aguarde...";
            $('#consultaElegibilidade').modal('show');

            this.$util.atualizar(this, {
                service: "acesso_operadoras",
                func: "consulta_elegibilidade",
                redir_api: true,
                dados: {
                    id_marcacao: this.marcacao ? this.marcacao.id_marcacao : null,
                },
                callback: res => {
                    this.solicitacao_elegibilidade = res;
                }
            });
        },

        refazerElegibilidade() {
            this.$emit('changeElegebilidade', null);
            this.fecharConsulta();
        }
    }

}
</script>
